var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwesomeTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-trophy",
    "data-name": "Icon awesome-trophy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-trophy-2",
    "data-name": "Icon awesome-trophy",
    d: "M17.25,2H14V.75A.748.748,0,0,0,13.25,0H4.75A.748.748,0,0,0,4,.75V2H.75A.748.748,0,0,0,0,2.75V4.5A4.078,4.078,0,0,0,1.934,7.647a7.321,7.321,0,0,0,3.437,1.3A6.912,6.912,0,0,0,7.5,11.25V13.5H6a1.8,1.8,0,0,0-2,1.75v.375A.376.376,0,0,0,4.375,16h9.25A.376.376,0,0,0,14,15.625V15.25a1.8,1.8,0,0,0-2-1.75H10.5V11.25a6.912,6.912,0,0,0,2.128-2.3,7.3,7.3,0,0,0,3.437-1.3A4.086,4.086,0,0,0,18,4.5V2.75A.748.748,0,0,0,17.25,2ZM3.1,6.025A2.3,2.3,0,0,1,2,4.5V4H4.006a11.224,11.224,0,0,0,.4,2.694A5.036,5.036,0,0,1,3.1,6.025ZM16,4.5a2.4,2.4,0,0,1-1.1,1.525,5.056,5.056,0,0,1-1.306.669A11.224,11.224,0,0,0,13.991,4H16Z",
    fill: "#455a64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeTrophy);
export default __webpack_public_path__ + "static/media/awesome-trophy.d6b2c588389b671b509845e812f9d3e0.svg";
export { ForwardRef as ReactComponent };